"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@dynamynd/core");

var react_1 = __importDefault(require("react"));

var react_redux_1 = require("react-redux");

var redux_1 = require("redux");

var store_1 = require("../store");

exports.withFeature = function (feature, route) {
  return function (WrappedComponent) {
    var WithFeature = function WithFeature(_a) {
      var features = _a.features,
          navigateTo = _a.navigateTo,
          rest = __rest(_a, ["features", "navigateTo"]);

      if (!features[feature]) {
        navigateTo(route);
        return null;
      }

      return react_1.default.createElement(WrappedComponent, __assign({}, rest));
    };

    var mapStateToProps = function mapStateToProps(state) {
      return {
        features: store_1.featuresSelector(state)
      };
    };

    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
      return {
        navigateTo: redux_1.bindActionCreators(core_1.navigateActionCreator, dispatch)
      };
    };

    var hoc = react_redux_1.connect(mapStateToProps, mapDispatchToProps);
    return hoc(WithFeature);
  };
};